import { render } from "./CommandLine.vue?vue&type=template&id=6744ceac&bindings={\"needObject\":\"props\",\"disabled\":\"props\",\"verb\":\"props\",\"subject\":\"props\",\"object\":\"props\",\"thingHoveredOn\":\"props\",\"lastCommand\":\"props\",\"describe\":\"options\",\"choosenText\":\"options\",\"possibleText\":\"options\",\"commandInProgessText\":\"options\"}"
import script from "./CommandLine.vue?vue&type=script&lang=js"
export * from "./CommandLine.vue?vue&type=script&lang=js"

import "./CommandLine.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script